// @ts-nocheck
import React, { useState } from "react";
import SoftBox from "../../../components/common/softBox";
import SoftTypography from "../../../components/common/softTypography";
import SoftInput from "../../../components/common/softInput";
import SoftButton from "../../../components/common/softButton";
import { useDispatch } from "react-redux";
import { createSalesOrderRequisitionConfig } from "../../../features/salesOrderRequisitionConfig";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import DashboardNavbar from "../../../components/navbars/dashboardNavbar";
import { Grid } from "@mui/material";

const FIELDS = [
  { name: "companyCode", label: "Company Code" },
  { name: "plant", label: "Plant" },
  { name: "salesOrg", label: "Sales Org" },
  { name: "distributionChannel", label: "Distribution Channel" },
  { name: "division", label: "Division" },
];

const AddSalesOrderRequisitionConfig = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    companyCode: "",
    plant: "",
    salesOrg: "",
    distributionChannel: "",
    division: "",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    dispatch(createSalesOrderRequisitionConfig(formData))
      .then((resultAction) => {
        if (
          createSalesOrderRequisitionConfig.rejected.match(resultAction)
        ) {
          toast.error(
            resultAction.payload?.message ||
              "Failed to create configuration."
          );
        } else {
          toast.success("Configuration created successfully.");
          navigate("/sale-order-requisition-configuration");
        }
      })
      .catch((err) => {
        console.error(err, "error");
        toast.error("Failed to create configuration.");
      });
  };

  return (
    <SoftBox className="language-box">
      <DashboardNavbar />
      <SoftBox
        sx={{
          padding: "15px",
          backgroundColor: "#fff",
          boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;",
        }}
      >
        <SoftBox mb={2}>
          <SoftTypography variant="h4" fontWeight="bold" textAlign="left">
            Add Sales Order Requisition Configuration
          </SoftTypography>
        </SoftBox>
        <SoftBox component="form" role="form">
          <Grid container spacing={2}>
            {FIELDS.map((field) => (
              <Grid item md={6} xs={12} key={field.name}>
                <SoftBox mb={1} ml={0.5}>
                  <SoftTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    {field.label}
                  </SoftTypography>
                </SoftBox>
                <SoftInput
                  type="text"
                  name={field.name}
                  placeholder={`Enter ${field.label}`}
                  value={formData[field.name]}
                  onChange={handleChange}
                />
              </Grid>
            ))}
          </Grid>

          <SoftBox mt={4} mb={1}>
            <SoftButton
              variant="gradient"
              color="final"
              fullWidth
              onClick={handleSubmit}
            >
              Submit
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default AddSalesOrderRequisitionConfig;
